export default {
  text_one: 'Gana {{count}} punto',
  text_other: 'Gana {{count}} puntos',
};
